import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFieldRadioGroup } from '~/components/FormField/components/FormFieldRadioGroup';
import { USER_STATUS } from '~settings/constants/Filter';
import { translateOptions } from '~settings/utils/helpers';

interface UserStatusProps
  extends Omit<ComponentProps<typeof FormFieldRadioGroup>, 'label' | 'options'>,
    Partial<Pick<ComponentProps<typeof FormFieldRadioGroup>, 'label'>> {}

export function UserStatus({ ...props }: UserStatusProps) {
  const { t } = useTranslation('settings');

  return (
    <FormFieldRadioGroup
      label={t('userStatus')}
      {...props}
      options={translateOptions(USER_STATUS, t)}
    />
  );
}

UserStatus.displayName = 'UserStatus';
